import { ControlledInputs, PrimaryButton } from '@/components';
import { Stack } from '@mui/material';
import { useForm } from 'react-hook-form';

export const TransactionsOptionHead = () => {
  const form = useForm();
  return (
    <Stack direction="row" justifyContent="space-between" pl={2} pb={3}>
      Tickets
      <Stack direction="row" gap={2}>
        <Stack width={300}>
          <ControlledInputs.TextField
            placeholder="Search a user"
            ControllerProps={{
              control: form.control,
              name: 'email',
            }}
          />
        </Stack>
        <Stack width={300}>
          <ControlledInputs.TextField
            placeholder="Date"
            ControllerProps={{
              control: form.control,
              name: 'email',
            }}
          />
        </Stack>
        <PrimaryButton>Export</PrimaryButton>
      </Stack>
    </Stack>
  );
};
